if (!customElements.get('lta-stock-notice')) {
  customElements.define('lta-stock-notice', class extends HTMLElement {
    connectedCallback() {
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.html.querySelector('product-info[data-product-id]')?.dataset.productId === this.dataset.productId) {
          this.hidden = data.variant.available !== false;
        }
      });
      this.onVariantInput = (event) => {
        if (event.target.matches('product-info .product-variant-id') && event.target.value === '') this.hidden = true;
      };
      document.addEventListener('change', this.onVariantInput);
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      document.removeEventListener('change', this.onVariantInput);
    }
  });
}
